"use strict";

var React = require("react");
module.exports = React.createElement(
  "svg",
  { viewBox: "0 0 36 36" },
  React.createElement("path", { d: "M20.454 8L5.084 23.372a1 1 0 0 0-.251.421L2.055 33.1c-.114.376.459.851.783.851a.274.274 0 0 0 .061-.006c.276-.064 7.867-2.344 9.312-2.779a.981.981 0 0 0 .414-.249L28 15.544zM11.4 29.316c-2.161.649-4.862 1.465-6.729 2.022l2.009-6.73zM33.567 8.2L27.8 2.432a1.214 1.214 0 0 0-.866-.353H26.9a1.371 1.371 0 0 0-.927.406l-4.1 4.1 7.543 7.542 4.1-4.1a1.374 1.374 0 0 0 .4-.883 1.222 1.222 0 0 0-.349-.944z" })
);

